module.exports = __webpack_public_path__ + "img/invoiceDis.6621e25d.png";